import styled from "@emotion/styled";
import ChevronLeftRounded from "@mui/icons-material/ChevronLeftRounded";
import ChevronRightRoundedIcon from "@mui/icons-material/ChevronRightRounded";
import { Button } from "@mui/material";
import "react-slideshow-image/dist/styles.css";

export const ImageTile = styled.div`
  max-width: 700px;
  margin: 0 auto;

  @media (max-width: 899px) {
    margin: 25px auto 0 auto;
  }
`;

export const ImageTitle = styled.h2`
  font-size: 22pt;
`;

export const Price = styled.p`
  margin-top: 20px;
  font-size: 22pt;
`;

export const SpecTitle = styled.p`
  font-size: 14pt;
`;

export const Specs = styled.ul`
  margin: 5pt 0;
`;

export const Spec = styled.li`
  line-height: 20pt;
`;

export const ShippingInfo = styled.p`
  font-size: 10pt;
  margin-top: 6px;
`;

export const AlreadyInCart = styled.span`
  font-size: 10pt;
  padding: 5px 10px;
  margin-top: 6px;
  border: 1px solid #ccc;
  display: inline-block;
  border-radius: 10px;
`

export const SliderButton = styled.button`
  width: 40px;
  height: 40px;
  border: 0;
  background-color: rgba(255, 255, 255, 0.2);
  border-radius: 40px;
  padding: 2px 0 0 0;
  margin: 10px;
  &:hover {
    background-color: rgba(255, 255, 255, 0.4);
  }
`;

export const CartButton = styled(Button)`
  text-transform: none;
  margin-top: 8px;
  border-radius: 5px;
  background-color: #f1641e;
  font-family: "Raleway";

  &:hover {
    background-color:rgb(195, 82, 25);
  }
`

export const NotAvailable = styled.span`
  font-size: 10pt;
  color: #666;
  border: 1px solid #ccc;
  padding: 5px 10px;
  border-radius: 5px;
  display: inline-block;
`

export const slider = {
  indicators: true,
  prevArrow: (
    <SliderButton>
      <ChevronLeftRounded fontSize="large" />
    </SliderButton>
  ),
  nextArrow: (
    <SliderButton>
      <ChevronRightRoundedIcon fontSize="large" />
    </SliderButton>
  ),
};
